export const COLORS = {
  textLightGrey: '#888B90',
  textLightGray: '#888B90',
  textDarkGray: '#888B90',
  textDarkGrey: '#888B90',
  darkBg: '#050528',
  drawerBg: '#313131',
  darkBox: '#313131',
  darkBoxOpacity: '#34314022',
  lightBg: '#ffffff',
  white: '#ffffff',
  whiteOpacity: 'rgba(255, 255, 255, 0.8)',
  blackOpacity: 'rgba(0, 0, 0, 0.8)',
  blackCardOpacity: 'rgba(0,0,0,0.4)',
  whiteCardOpacity: 'rgba(255,255,255,0.4)',
  black: '#000',
  darkGray: '#303030',
  darkGrey: '#333333',
  lightGrey: '#e9e9e9',
  lightGray: '#ddd',
  lightSilver: '#888b90',
  darkBorder: '#ccc',
  lightBorder: '#555',
  subHeaderDark: '#242424',
  subHeaderLight: '#FBFBFB',
  shadowDark: '#333',
  shadowLight: '#eee',
  loginbgb: '#1d1003',
  loginbgw: '#ffd7cb',
  grad1: '#7e39ff',
  grad2: '#3172fd',
};
export const theme: {
  light: { COLORS: any };
  dark: { COLORS: any };
} = {
  dark: {
    COLORS: {
      background: COLORS.darkBg,
      bgColor: COLORS.black,
      drawerBgColor: COLORS.drawerBg,
      mdrawerBgColor: '#343140',
      tradeBG: '#050528',
      opacityBgColor: COLORS.blackOpacity,
      descBox: COLORS.darkBox,
      textsilver: COLORS.lightSilver,
      gray: COLORS.darkGray,
      grey: COLORS.darkGrey,
      textw: COLORS.white,
      textGrey: COLORS.textLightGrey,
      textGray: COLORS.textLightGrey,
      borderColor: COLORS.lightBorder,
      header: COLORS.darkGray,
      subHeader: COLORS.subHeaderDark,
      shadow: COLORS.shadowDark,
      cardOpacity: COLORS.blackCardOpacity,
      content: '#ddd',
      stroke: '#2F2F2F',
      Secondary: '#EFEFEF',
      Tertiary: '#707A8A',
      onSecondary: '#CBD1D7',
      onTertiary: '#000000',
      fail_sub: '#37A16A1A',
      Prinary: '#ffffff',
      raise_sub: '#37A16A1A',
      point: '#00499F',
      complementary: '#1D1D1D',
      fail: '#F6465D',
      raise: '#2EBD85',
      descBorder: COLORS.darkBorder,

      tabMenuActive: '#007AFF',
      tabMenuInactive: '#83838C',
      tabMenuMobileBorder: '#333333',
      tabMenuHover: '#3D3D3D',

      descText: '#9897A0',
      listIconBorder: '#1f1f1f',
      listIconBackground: '#333',
      itemTitle: '#fff',
      itemContent: '#C8C8D2',
      itemSubTitle: '#F5F5F5',
      itemBg: '#1F1F1F',

      tableBg: '#0B0E11',
      searchText: '#757575',
      tableBtn: '#333333',
      sectionDesc: '#B5B5BC',

      positiveItem: '#0DCB81',

      memuHover: '#007AFF',
      subMenuHover: '#333',

      gridBorder: '#272B38',
      numberText: '#EAECEF',
      transactionTableBorder: '#303030',
      mobileTradeBorder: '#5D5D5D',

      //FossX
      ButtonBg: '#1F1F1F',
      ButtonBorder: '#333333',
      PrimaryBg: '#0B0E11',
      PrimaryBorder: '#333333',
      SocialButtonBg: 'rgba(31, 31, 31, 0.5)',
      GrayDesText: '#B5B5BC',
      SecondaryBorder: '#333333',
      MobileSecondaryBorder: '#83838C',
      BoxBg: 'rgba(25, 26, 25, 0.6)',
      SubmenuBorder: '#333333',
      SubmenuBg: 'rgba(25, 26, 25, 0.6)',
      DropdownBg: 'rgba(25, 26, 25, 1)',
      DropdownHoverBg: 'rgb(39, 41, 39)',
      PrimaryInputBg: '#1F1F1F',
      PrimaryInputBorder: '#333333',
      PrimaryTableBg: '#0B0E11',
      PrimaryTableBorder: '#333333',
      CardBorder: '#333333',
      CardBg: '#0B0E11',
      SecondaryCardBg: '#91C6FF',
      ModalBg: '#1F1F1F',
      ModalBorder: '#333333',
      greenText: '#00FF9C',
      tradeAreaBg: '#0B0E11',
      tradeAreaBorder: '#1e1e1e',
      tradeGridBg: '#000000',
      innerCardBg: COLORS.blackCardOpacity,
      IconBorder: '#D5D5D5',
      SocialIconBg: '#2A2A2A',
      SocialIconFg: '#FFFFFF',
      tableDivider: 'rgba(255, 255, 255, 0.12)',
    },
  },
  light: {
    COLORS: {
      background: COLORS.lightBg,
      drawerBgColor: '#FAFAFA',
      mdrawerBgColor: COLORS.white,
      tradeBG: '#ededed',
      opacityBgColor: COLORS.whiteOpacity,
      descBox: COLORS.darkBoxOpacity,
      bgColor: COLORS.white,
      textsilver: COLORS.lightSilver,
      gray: COLORS.lightGray,
      grey: COLORS.lightGrey,
      textw: COLORS.black,
      textGrey: COLORS.textLightGrey,
      textGray: COLORS.textLightGrey,
      borderColor: COLORS.darkBorder,
      header: COLORS.white,
      subHeader: COLORS.subHeaderLight,
      shadow: COLORS.shadowLight,
      cardOpacity: COLORS.whiteCardOpacity,
      content: '#999',
      onTertiary: '#F2F4F6',
      fail_sub: '#37A16A1A',
      fail: '#F71053',
      raise: '#37A16A',
      raise_sub: '#37A16A1A',
      stroke: '#EAEAEA',
      onSecondary: '#EDEFF1',
      Prinary: '#303030',
      point: '#00499F',
      Tertiary: '#848E9C',
      Secondary: '#3A3A3A',
      descBorder: COLORS.lightBorder,

      tabMenuActive: '#007AFF',
      tabMenuInactive: '#BDBDBD',
      tabMenuMobileBorder: '#EFD9D0',
      tabMenuHover: '#f5f5f5',

      descText: '#9E9E9E',
      listIconBorder: '#F6E8E5',
      listIconBackground: '#F3E2DD',
      itemTitle: '#212121',
      itemContent: '#616161',
      itemSubTitle: '#424242',
      itemBg: 'rgb(253, 253, 253)',

      tableBg: '#F6EDEA',
      searchText: '#757575',
      tableBtn: '#DDE0F3',
      sectionDesc: '#757575',

      positiveItem: '#0DCB81',

      memuHover: '#007AFF',
      subMenuHover: '#EFD6C8',

      gridBorder: '#E2E5EE',
      numberText: '#202630',
      transactionTableBorder: '#ddd',
      mobileTradeBorder: '#ddd',

      //FossX
      ButtonBg: 'rgba(255, 255, 255, 0.5)',
      ButtonBorder: '#DDE0F3',
      PrimaryBg: 'rgb(253, 253, 253)',
      PrimaryBorder: '#DDE0F3',
      SocialButtonBg: 'rgba(255, 255, 255, 0.5)',
      GrayDesText: '#333333',
      SecondaryBorder: 'B5B5BC',
      MobileSecondaryBorder: '#BDBDBD',
      BoxBg: 'rgba(234, 235, 246, 0.6)',
      SubmenuBorder: '#C8D6Ef',
      SubmenuBg: '#F0F1F8',
      DropdownBg: 'rgb(253, 253, 253)',
      DropdownHoverBg: 'rgb(229, 231, 241)',
      PrimaryInputBg: 'rgb(253, 253, 253)',
      PrimaryInputBorder: '#DDE0F3',
      PrimaryTableBg: 'rgb(250, 250, 252)',
      PrimaryTableBorder: '#C8D6Ef',
      CardBorder: '#C8D6Ef',
      CardBg: '#F0F1F8',
      SecondaryCardBg: '#91C6FF',
      ModalBg: 'rgb(253, 253, 253)',
      ModalBorder: '#DDE0F3',
      greenText: '#00B56F',
      tradeAreaBg: '#FFFFFF',
      tradeAreaBorder: '#eff0f1',
      tradeGridBg: '#fbfbfb',
      innerCardBg: COLORS.white,
      IconBorder: '#5d5d5d',
      SocialIconBg: '#007AFF10',
      SocialIconFg: '#212121',
      tableDivider: 'rgba(0, 0, 0, 0.08)',
    },
  },
};
